import styled from 'styled-components';
import { Paper } from '@material-ui/core';

export const PopoverContainer = styled(Paper)`
  &.MuiPaper-root {
    margin-top: 64px;
    padding: 16px 24px;
    border-radius: 2px;
    box-shadow: 0 0 4px 0 rgba(18, 26, 61, 0.17);
    position: relative;
    width: 227px;
    overflow: visible;
    
    &:before {
      content: '';
      position: absolute;
      top: -12px;
      left: 0;
      right: 0;
      width: 24px;
      height: 24px;
      margin: auto;
      transform: rotate(45deg);
      background: inherit;
      box-shadow: -3px -3px 4px -2px rgba(18,26,61,0.17);
    }
  }
`;